import * as tracking from '../../tracking';

import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';
import {FormattedMessage, injectIntl} from 'react-intl';
import React, {Component} from 'react';

import Button from '../../forecast-app/shared/components/buttons/button/button';
import RadioButton from '../new-ui/radio_button';
import UserSelectSideMenu from '../user_select_side_menu';
import {withRouter} from 'react-router-dom';
import DropdownV2 from '../../forecast-app/shared/components/dropdowns/dropdown';

class Licensing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showSideMenu: false,
		};
	}

	componentDidMount() {
		tracking.trackPage('trial-end-licensing');
	}

	setPage(page) {
		this.props.setPage(page);
	}

	handleFieldChange(property, e) {
		if (e.target.value && parseInt(e.target.value)) {
			if (parseInt(e.target.value) > 9999) {
				return;
			}
		}
		this.props.handleFieldChange(property, e);
	}

	handleClientSave(property) {
		this.props.handleClientSave(property);
	}

	toggleEditUserMenu() {
		this.setState(prevState => {
			return {showSideMenu: !prevState.showSideMenu};
		});
	}

	handleSideMenuBlur() {
		if (this.state.showSideMenu) {
			this.setState({showSideMenu: false});
		}
	}

	render() {
		const {formatMessage} = this.props.intl;
		const {users, virtualUsers, allPersons, minimumVirtualSeats, virtualSeats, minimumSeats, seats, canGoBack, selectedTier, selectPlan, selectCurrency, currency, currencies, plans} = this.props;

		const jiraEnabled = this.props.viewer.company.jiraCloudEnabled || this.props.viewer.company.jiraServerEnabled;
		const planDisabled = {
			light: jiraEnabled || !plans.some(plan => plan.chargebeeId.includes('_lite_') && plan.currency === currency),
			pro: !plans.some(plan => plan.chargebeeId.includes('_pro_') && plan.currency === currency),
			enterprise: !plans.some(plan => plan.chargebeeId.includes('_enterprise_') && plan.currency === currency),
		};

		return (
			<div className="licensing-v2">
				<div className="trial-end-card large">
					<h3 className="plan-headline">
						<div className="headline-text">{formatMessage({id: 'common.plan'})}</div>
					</h3>
					<div className={'plan-top-content'}>
						<div className={'plan-select'}>
							<div className="plan-option" onClick={() => (planDisabled.light ? null : selectPlan('LITE'))}>
								<RadioButton useOnclick={true} stateValue={selectedTier} value={'LITE'} onSelected={() => (planDisabled.light ? null : selectPlan('LITE'))} cy={'select-plan-radio-lite'} locked={planDisabled.light} />
								<div className={'radio-option-label'}>
									<FormattedMessage id="common.lite_plan" />
								</div>
								{jiraEnabled ? (
									<span className="jira-warning">
										*
										<FormattedMessage id="select_plan.jira-error-message" />
									</span>
								) : (
									''
								)}
							</div>
							<div className={'plan-option'} onClick={() => (planDisabled.pro ? null : selectPlan('PRO'))}>
								<RadioButton useOnclick={true} stateValue={selectedTier} value={'PRO'} onSelected={() => (planDisabled.pro ? null : selectPlan('PRO'))} cy={'select-plan-radio-pro'} locked={planDisabled.pro} />
								<div className={'radio-option-label'}>
									<FormattedMessage id="common.pro_plan" />
								</div>
							</div>
							<div className={'plan-option'} onClick={() => (planDisabled.enterprise ? null : selectPlan('ENTERPRISE'))}>
								<RadioButton
									useOnclick={false}
									stateValue={selectedTier}
									value={'ENTERPRISE'}
									onSelected={() => (planDisabled.enterprise ? null : selectPlan('ENTERPRISE'))}
									cy={'select-plan-radio-enterprise'}
									locked={planDisabled.enterprise}
								/>
								<div className={'radio-option-label'}>
									<FormattedMessage id="common.enterprise_plan" />
								</div>
							</div>
						</div>
					</div>
					<div className="currency-select">
						<DropdownV2 value={currency} options={currencies} label={'Currency'} onChange={selectCurrency.bind(this)} />
					</div>
					<UserSelectSideMenu onBlur={this.handleSideMenuBlur.bind(this)} shown={this.state.showSideMenu} users={allPersons.map(person => person.node)} viewerPersonId={this.props.viewer.actualPersonId} viewerId={this.props.viewer.id} />

					<h3 className="seat-licensing-headline">
						<div className="headline-text">{formatMessage({id: 'licensing.seat_licensing'})}</div>
						<Button id="edit-users-btn" text={'Edit Current Users'} colorTheme={BUTTON_COLOR.VERYLIGHTGREY} buttonStyle={BUTTON_STYLE.OUTLINE} onClick={this.toggleEditUserMenu.bind(this)} className={'edit-virtual-users-link'} />{' '}
					</h3>

					<div className="users-wrapper">
						<div className={'users'}>
							<label htmlFor="users">
								<div className="user-section-header">{formatMessage({id: 'settings_subscription.users'})}</div>
								<p className={'user-description'}>{formatMessage({id: 'company_details.user_description'})}</p>
								<div className="seat-wrapper">
									<p className={'amount-text'}>{formatMessage({id: 'company_details.current_users_amount'})}: </p>
									<p className={'amount-number'}>{users}</p>
								</div>
								<div className="seat-wrapper">
									<p className={'amount-text'}>
										<b>
											<span>{formatMessage({id: 'company_details.seats_amount'})}:</span>
										</b>
									</p>
									<input
										type="number"
										id="company_seats"
										className={!this.props.validateSeats() ? 'invalid' : ''}
										size="35"
										value={seats}
										min={users}
										placeholder={0}
										onChange={this.handleFieldChange.bind(this, 'seats')}
										data-cy={'seats-input'}
									/>
								</div>
								<div className="invalid-seats" data-cy={'seats-error'}>
									{seats < minimumSeats ? (
										<span>
											<FormattedMessage id="company_details.less_seats_than_plan_error" values={{amount: minimumSeats}} />
										</span>
									) : seats < users ? (
										<span>
											<FormattedMessage id="company_details.less_seats_than_users_error" />
										</span>
									) : (
										' '
									)}
								</div>
							</label>
						</div>
						<div className={'virtual-users'}>
							<label htmlFor="virtual-users">
								<div className="user-section-header">{formatMessage({id: 'settings_subscription.virtual_users'})}</div>
								<p className={'user-description'}>{formatMessage({id: 'company_details.virtual_user_description'})}</p>
								<div className="seat-wrapper">
									<p className={'amount-text'}>{formatMessage({id: 'company_details.current_virtual_users_amount'})}:</p>
									<p className={'amount-number'}>{virtualUsers}</p>
								</div>
								<div className="seat-wrapper">
									<p className={'amount-text'}>
										<b>
											<span>{formatMessage({id: 'company_details.virtual_seats_amount'})}:</span>
										</b>
									</p>
									<input
										type="number"
										id="company_virtual_seats"
										className={!this.props.validateVirtualSeats() ? 'invalid' : ''}
										size="35"
										value={virtualSeats}
										min={virtualUsers}
										placeholder={0}
										onChange={this.handleFieldChange.bind(this, 'virtualSeats')}
										data-cy={'virtual-seats-input'}
									/>
								</div>
								<div className="invalid-seats" data-cy={'seats-error'}>
									{virtualSeats < minimumVirtualSeats ? (
										<span>
											<FormattedMessage id="company_details.less_virtual_seats_than_plan_error" values={{amount: minimumVirtualSeats}} />
										</span>
									) : virtualSeats < virtualUsers ? (
										<span>
											<FormattedMessage id="company_details.less_seats_than_virtual_users_error" />
										</span>
									) : (
										' '
									)}
								</div>
							</label>
						</div>
					</div>
					<div className="buttons">
						{canGoBack ? (
							<Button className="back-button" onClick={this.props.setPage.bind(this, 'SELECT_PLAN')} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.WHITE} text={formatMessage({id: 'common.back'})} cy={'back-button'} />
						) : (
							<Button className="back-button" onClick={() => this.props.history.push('/')} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.WHITE} text={formatMessage({id: 'common.cancel'})} />
						)}

						<Button className="next-button" onClick={this.props.setPage.bind(this, 'ONBOARDING')} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.GREEN} text={formatMessage({id: 'common.next'})} cy={'next-button'} />
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(withRouter(Licensing));
